import { useState, useEffect } from 'react';
import { Platform } from 'react-native';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

// Default styles to use if Firestore doesn't have values
const defaultStyles = {
    venueScreenStyles: {
        venueName: {
            web: { color: "#FFCB98", fontSize: "3rem" },
            mobile: { color: "#FFCB98", fontSize: "2.5rem" }
        },
        venueAddress: {
            web: { color: "#000000", fontSize: "1.125rem" },
            mobile: { color: "#000000", fontSize: "1rem" }
        },
        website: {
            web: { color: "#7cff75", fontSize: "1rem" },
            mobile: { color: "#7cff75", fontSize: "0.875rem" }
        },
        affiliate: {
            web: { color: "#0f0f0f", fontSize: "16px" },
            mobile: { color: "#0f0f0f", fontSize: "16px" }
        }
    }
};

export const useSystemStyles = () => {
  const [styles, setStyles] = useState(defaultStyles);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStyles = async () => {
      try {
        const db = getFirestore();
        const stylesRef = doc(db, 'system', 'styles');
        const stylesDoc = await getDoc(stylesRef);
        
        if (stylesDoc.exists()) {
          // Merge with default styles to ensure all properties exist
          const firestoreStyles = stylesDoc.data();
          const mergedStyles = { ...defaultStyles };


          for (const screenStyle in defaultStyles) {
            if (firestoreStyles[screenStyle]) {
                Object.keys(defaultStyles[screenStyle]).forEach(key => {
                    if (firestoreStyles[screenStyle][key]) {
                        mergedStyles[screenStyle][key] = {
                          web: { ...defaultStyles[screenStyle][key].web, ...firestoreStyles[screenStyle][key].web },
                          mobile: { ...defaultStyles[screenStyle][key].mobile, ...firestoreStyles[screenStyle][key].mobile }
                        };
                    }
                });
            }
          }

          setStyles(mergedStyles);
        }
      } catch (err) {
        console.error('Error fetching system styles:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStyles();
  }, []);

  // Helper function to get the current platform's style for an element
  const getStyle = (screenStyle, element, platform=null) => {
    if (platform === null) {
        platform = Platform.OS === 'web' ? 'web' : 'mobile';
    }

    // If it's a single element, return the style for that element
    return styles[screenStyle][element][platform] || defaultStyles[screenStyle][element][platform];
  };

  return { styles, loading, error, getStyle };
}; 